<template>
    <div style="position: relative;z-index: 99999;">
      <van-popup 
        class="tree_popup win_tree_popup" 
        v-model="showTreePop" 
        closeable 
        close-icon="arrow-left"
        close-icon-position="top-left" 
        position="right" 
        teleport="body" 
        overlay-class="win_tree_popup_overlay"
        :style="{ width: '100%', height: '100%' }"
      >
        <van-sticky class="fixed_div">
          <div class="tree_title">
            <span>{{ `请选择${treeTitle}` }}</span>
          </div>
          <div class="tree_search">
            <van-search v-model="searchTreeVal" placeholder="请输入搜索关键词" @search="onSearchTree"  @input="onSearchTree"/>
          </div>
          <div class="tree_head">
            <span class="head_start" @click="backTo(true)">开始</span>
            <span v-for="(ele, idex) in clickParentTree" :key="idex"
              :class="idex == clickParentTree.length - 1 ? 'theLast' : 'noLast'" @click="backTo(ele)">
              <span class="division">
                <img src="@/assets/img/divisionPng.png" alt="">
              </span>
              {{ ele.keyname }}
            </span>
          </div>
          <van-divider :style="{
            color: '#E8E8E8',
            borderColor: '#E8E8E8',
            margin: '5px 0 0 0',
          }" />
        </van-sticky>
        <van-sticky class="fixed_div">
          <div class="quanXuanClass">
            <van-checkbox v-model="quanXuanModel" @click="quanXuanClick">全选</van-checkbox>
          </div>
        </van-sticky>
        <van-divider :style="{
            color: '#E8E8E8',
            borderColor: '#E8E8E8',
            margin: '5px 0 0 0',
          }" />
        <div 
          class="tree_body"
          :class="[multiseltree ? 'multiseltreeT' : '', (whichTree == 'station' || whichTree == 'employee') && childsTreeList.length > 0 && !multiseltree ? 'single_pagination_tree' : (whichTree == 'station' || whichTree == 'employee') && childsTreeList.length > 0 && multiseltree ? 'unSingle_pagination_tree' : '']">
          <!-- 岗位树和员工树 -->
          <div class="staOrEmp_tree">
            <!-- 多选树 -->
            <div v-if="multiseltree" class="multisel_tree ccc">
              <!-- 父节点 -->
              <van-cell  class="parents_cell" v-for="(item, index) in parentTreeList" :key="index + item.keyname"
                >
                <template #default>
                  <div :class="item.checked ? 'noClo' : 'haveClo'" @click="checkParent(item)">
                    <van-icon name="arrow-down" />
                    <span>下级</span>
                  </div>
                </template>
                <template #title>
                  <van-checkbox  v-model="item.checked" @click="tickParent(item,index)">
                    <span :class="item.blueShow || item.checked?'titleShowBlueClass':''" style="font-weight: bold;">{{ item.keyname }}</span>
                    <span style="color: #ccc;">{{ '（'+item.empcount+'）' }}</span>
                  </van-checkbox>
                </template>
              </van-cell>
              <!-- 子节点 -->
              <van-cell class="childs_cell" v-for="(it, idx) in childsTreeList" :key="idx">
                <template #title>
                  <van-checkbox v-model="it.checked" @click="childTickParent(it,idx)">
                    <van-button size="small" :icon="whichTree == 'employee' ? 'user-o' : 'manager-o'"
                      :type="whichTree == 'employee' ? 'warning' : 'primary'"></van-button>
                    <span class="check_name">{{ it.keyname }}</span>
                  </van-checkbox>
                </template>
              </van-cell>
            </div>
            <!-- 非多选 -->
            <div v-else class="unMultisel_tree">
              <!-- 父节点 -->
              <van-cell :class="item.blueShow?'titleShowBlueClass':''" class="parents_cell" v-for="(item, index) in parentTreeList" :key="index + item.keyname"
                :title="item.keyname+'('+item.childLength+')'" @click="checkParent(item)">
                <template #default>
                  <div :class="item.hasLower ? 'haveClo' : 'noClo'">
                    <van-icon name="arrow-down" />
                    <span>下级</span>
                  </div>
                </template>
              </van-cell>
              <!-- 子节点 -->
              <van-cell class="childs_cell" v-for="(it, idx) in childsTreeList" :key="idx" @click="checkChild(it)">
                <template #title>
                  <van-button size="small" :icon="whichTree == 'employee' ? 'user-o' : 'manager-o'"
                    :type="whichTree == 'employee' ? 'warning' : 'primary'"></van-button>
                  <span class="check_name">{{ it.keyname }}</span>
                </template>
              </van-cell>
            </div>
          </div>
        </div>
        <div class="pagination_box" v-if="(whichTree == 'station' || whichTree == 'employee') && childsTreeList.length > 0">
          <van-pagination v-model="currentPage" :total-items="totalItems" :items-per-page="pageSize" :show-page-size="3"
            force-ellipses @change="changePage" />
        </div>
        <div class="tree_foot2" v-if="multiseltree">
          <div class="foot2Left" @click="popAllSelectFun">
            <div class="foot2LeftTop">
              <span class="foot2LeftTopWord">已选择：</span>
              <img class="foot2LeftTopImg" src="@/assets/img/yuanGSLXZ.png" alt="">
            </div>
            <div class="foot2LeftBottom">
              {{ zsEmpInfo.length }}人！{{ xsEmpName }}
            </div>
          </div>
          <van-button class="foot2Right" type="info" @click="comfirmChecked">确定</van-button>
        </div>
      </van-popup>
      <van-popup v-model="showGjPicker" round position="bottom">
        <van-picker show-toolbar :columns="gjcolumns" value-key="partname" :confirm-button-text="$t('module.confirm')"
          :cancel-button-text="$t('module.cancel')" @cancel="showGjPicker = false" @confirm="onConfirmGj" />
      </van-popup>
      <van-popup class="winAllSelectZindexDiv" v-model="showAllSelectStatus" round position="bottom" overlay-class="winAllSelectZindex">
        <div>
          <div class="winAllSelectZindexDiv_Top">
            <div class="winAllSelectZindexDiv_TopWord">
              已选择：{{ zsEmpInfo.length }}人
            </div>
          </div>
          <div class="winAllSelectZindexDiv_search">
            <van-search placeholder="请输入搜索关键词" v-model="searchZsEmpInfoVal" @input="onSelectPSearch" />
          </div>
          <div style="width: 100%;height: 5px;background: #E8E8E8;"></div>
          <div class="winAllSelectZindexDiv_info">
            <div class="winAllSelectZindexDiv_infoBox" v-for="(value,key) in showEmpInfo" :key="key">
              <div class="winAllSelectZindexDiv_infoLeft">
                <img class="winAllSelectZindexDiv_infoLeftImg" src="@/assets/img/winAllSelectZindexDivYg.png" alt="">
              </div>
              <div class="winAllSelectZindexDiv_infoRight">
                <div class="winAllSelectZindexDiv_infoRightUser">
                  <div class="winAllSelectZindexDiv_infoRightUserName">{{ value.empname }}</div>
                  <div class="winAllSelectZindexDiv_infoRightUserCode">工号：{{ value.empcode }}</div>
                </div>
                <div class="winAllSelectZindexDiv_infoRightBtn">
                  <van-button type="default" class="winAllSelectZindexDiv_infoRightBtnBtn" @click="ycZsEmp(value,key)">移除</van-button>
                </div>
              </div>
            </div>
          </div>
          <div class="winAllSelectZindexDiv_FenYe" v-if="zsEmpInfo.length > pageSize2 && noHidden">
            <van-pagination @change="zeEmpInfoChange" v-model="FenYeCurrentPage" :total-items="zsEmpInfo.length" :items-per-page="pageSize2" />
          </div>
          <div class="winAllSelectZindexDiv_Footer">
            <van-button plain type="info" class="btn11" @click="showAllSelectStatus = false">返回</van-button>
            <van-button type="info" class="btn22" @click="showAllSelectStatus = false">确定</van-button>
          </div>
        </div>
      </van-popup>
    </div>
  </template>
  <script>
  import { getCommTreeData } from "@api/wxjx.js";
  import { getSelTreeLevel,getDeptEmpList,getEmpDeptAutoIdList } from "@api/wx.js";
  import {
    getJobList
  } from "@api/paigong.js";
  import { Toast } from "vant";
  export default {
    name: "PopTree",
    props: {
      // 树的类型
      whichTree: {
        type: String,
        default: "calitemtree",
      },
      // true代表多选
      multiseltree: {
        type: Boolean,
        default: false,
      },
      // 是否开启工位
      job: {
        type: Boolean,
        default: false,
      },
      // 来自哪里
      whereFrom: {
        type: String,
        default: "",
      }
    },
    data () {
      const userInfo = localStorage.userInfo
        ? JSON.parse(localStorage.userInfo)
        : {};
      return {
        userInfo,
        showTreePop: false, // 显示树
        searchTreeVal: "", // 树弹窗搜索词
        allTreeList: [], // 所有树集合
        parentTreeList: [], // 上级树集合（针对岗位树和员工数）
        allChildsTreeList: [],
        childsTreeList: [], // 下级树集合（针对岗位树和员工数）
        clickParentTree: [], // 储存点击过的父节点
        otherTreeList: [], // 其他类型树集合
        canComfirm: false, // 多选树确定按钮是否可以点击
        toWitchCode: "", // 赋值哪个工号
        clickKeyId: "",
        treeTitle: "",
        module: "",
        editstate: 2,
        treename: "",
        treeLevel: -1,
        jobName: "",
        jobId: null,
        gjcolumns: [],
        bfgjcolumns: [],
        showGjPicker: false,
        fieldname: '',
        xiaYiJi: null,
        currentPage: 1,
        totalItems: 0,
        pageSize: 10,
        quanXuanModel:false,
        xsEmpName:"",
        zsEmpInfo:[],
        showAllSelectStatus:false,
        FenYeCurrentPage:1,
        showEmpInfo:[],
        pageSize2:window.pop_tree_pagesize || 20,
        noHidden:true,
        searchZsEmpInfoVal:"",
        isZB:false,
        formautoid:0
        // bianLiCiShu:0
      };
    },
    watch: {
      showTreePop (n) {
        if (n == false)
        {
          this.parentTreeList = []; // 上级树集合
          this.childsTreeList = []; // 子节点
          this.clickParentTree = []; // 点击过的父节点
          this.otherTreeList = []; // 其他树节点
          this.searchTreeVal = "";
          this.isZB = false;
          this.formautoid = 0
        } else
        {
          let pagesize = window.pop_tree_pagesize ? window.pop_tree_pagesize : 10
          this.pageSize = Number(pagesize)
        }
      },
    },
    methods: {
      // 岗位和人员分页
      changePage () {
        this.childsTreeList = this.allChildsTreeList.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
        this.$forceUpdate()
      },
      // 打开树
      showEmpTreePop (val, code) {
        this.toWitchCode = code;
        this.treeTitle = val;
        this.showTreePop = true;
        this.clickKeyId = "";
        this.jobId = null;
        this.jobName = "";
        this.quanXuanModel = false;
        this.xsEmpName = "";
        this.zsEmpInfo = [];
        this.showAllSelectStatus = false;
        this.FenYeCurrentPage = 1;
        this.showEmpInfo = [];
        this.pageSize2 = window.pop_tree_pagesize || 20;
        this.noHidden = true;
        this.searchZsEmpInfoVal = "";
        this.getSelTreeLevelEvent();
      },
      getSelJobEvent () {
        getJobList({
          username: this.userInfo.username,
        }).then(res => {
          this.bfgjcolumns = res.data;
          if (res.data.length > 0)
          {
            for (let i = 0; i < res.data.length; i++)
            {
              this.gjcolumns.push(res.data[i].jobname);
            }
          }
        })
      },
      onConfirmGj (value) {
        let arr = this.bfgjcolumns.filter((item) => {
          return item.jobname == value;
        });
        this.jobName = value;
        this.jobId = arr[0].jobid;
        this.showGjPicker = false
      },
      getSelTreeLevelEvent () {
        getSelTreeLevel({
          moduleno: this.module,
          treename: this.treename, // 树名
          username: this.userInfo.username,
        }).then((res) => {
          console.log(res);
          this.treeLevel = res.data[0].levelid;
          this.getCommTree();
        });
      },
      // 获取通用树
      async getCommTree () {
        await getCommTreeData({
          moduleno: this.module,
          treename: this.treename, // 树名
          username: this.userInfo.username,
          fieldname: this.isZB?'zb_emptree':(this.treename == 'emptree' && this.whereFrom == 'hrQueryPage' ? 'app_select_emplist' : this.fieldname),
          editstate: this.isZB?this.formautoid:this.editstate,
          formstr: "",
        }).then((res) => {
          // 如果是多选树，则返回记录添加是否多选，是否选中属性
          if (this.multiseltree)
          {
            res.data.forEach((element) => {
              element.multiple = this.multiseltree;
              element.checked = false;
            });
          }
          this.allTreeList = res.data;
  
          // 树结构中最小层级(最上层)
          let mini = Math.min.apply(
            Math,
            res.data.map((item) => {
              return item.levelid;
            })
          );
          if (this.whichTree == "station" || this.whichTree == "employee")
          {
            // console.log(this.allTreeList,'this.allTreeList')
            // 岗位和员工树
            // 初始时的父节点
            this.parentTreeList = res.data.filter((item) => {
              return item.levelid == mini;
            });
            
            if(this.parentTreeList.length > 0){
              this.parentTreeList.forEach(item=>{
                let array = this.allTreeList.filter((item2) => {
                  return item2.parentid == item.keyid;
                });
                item.childLength = array.length
              })
              console.log(this.parentTreeList,'this.parentTreeList')
            }
            
            // 判断父节点有没有下级
            if (this.parentTreeList.length > 0)
            {
              this.parentTreeList.forEach((el) => {
                el.hasLower = false;
                for (let i = 0; i < this.allTreeList.length; i++)
                {
                  const it = this.allTreeList[i];
                  if (el.keyid == it.parentid)
                  {
                    el.hasLower = true;
                    break;
                  }
                }
              });
            }
            // 初始时的子节点
            let initchilds = []
            this.allTreeList.forEach((el) => {
              if (this.parentTreeList.length == 1)
              {
                // 最大父节点只有一个的时候
                let nodecan = false;
                if (this.whichTree == "station")
                {
                  nodecan = el.issta;
                } else if (this.whichTree == "employee")
                {
                  nodecan = el.isdept == 0 && el.levelid == 16;
                }
                if (nodecan && el.parentid == this.parentTreeList[0].keyid)
                {
                  initchilds.push(el)
                }
              } else
              {
                // 最大父节点有多个的时候
                this.childsTreeList = [];
              }
            });
            this.currentPage = 1
            this.totalItems = initchilds.length
            this.allChildsTreeList = initchilds
            this.childsTreeList = initchilds.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
          } else
          {
            // 其他树(暂时部门树)
            // 初始时的节点
            this.otherTreeList = res.data.filter((item) => {
              return item.levelid == mini;
            });
            // 判断初始节点有没有下级
            if (this.otherTreeList.length > 0)
            {
              this.otherTreeList.forEach((el) => {
                el.hasLower = false;
                for (let i = 0; i < this.allTreeList.length; i++)
                {
                  const it = this.allTreeList[i];
                  if (el.keyid == it.parentid)
                  {
                    el.hasLower = true;
                    break;
                  }
                }
              });
            }
          }
        });
      },
      // 搜索子节点
      onSearchTree (val) {
        this.quanXuanModel = false;
        // 清空父节点、子节点和已点击过的父节点
        this.parentTreeList = [];
        this.childsTreeList = [];
        this.clickParentTree = [];
        this.otherTreeList = [];
        let initchilds = []
        this.allTreeList.forEach((el) => {
          let nodecan = false;
          if (this.whichTree == "station")
          {
            nodecan = el.issta;
          } else if (this.whichTree == "employee")
          {
            nodecan = el.isdept == 0 && el.levelid == 16;
          }
          // 岗位和人员
          if (this.whichTree == "station" || this.whichTree == "employee")
          {
            if (nodecan && el.keyname.indexOf(val) !== -1)
            {
              initchilds.push(el)
              // this.childsTreeList.push(el);
            }
          } // 其他（部门）
          else
          {
            if (el.keyname.indexOf(val) !== -1)
            {
              // 判断节点有没有下级
              let lowerAry = this.allTreeList.filter((it) => {
                return it.parentid == el.keyid;
              });
              if (lowerAry.length > 0)
              {
                el.hasLower = true;
              } else
              {
                el.hasLower = false;
              }
              this.otherTreeList.push(el);
            }
          }
        });
        // 岗位和人员
        if (this.whichTree == "station" || this.whichTree == "employee")
        {
          this.currentPage = 1
          this.totalItems = initchilds.length
          this.allChildsTreeList = initchilds
          this.childsTreeList = initchilds.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
        }
      },
      // 回到某个树节点
      async backTo (val) {
        
        // 判断是否全部选中 如果全部选中 就全选 其它都非全选
        if (val === true)
        {
          // 点击的开始,回到最初始状态
          this.parentTreeList = [];
          this.childsTreeList = [];
          this.clickParentTree = [];
          this.otherTreeList = [];
          this.searchTreeVal = "";
          this.allTreeList = [];
          await this.getCommTree(this.multiseltree);
          this.checkKeyIdBlue(this.clickParentTree)
        } else
        {
          // 否则先在clickParentTree去掉该父节点及节点后所有节点
          let ary = []; // 记录该节点及后的所有节点
          for (let i = 0; i < this.clickParentTree.length; i++)
          {
            const ele = this.clickParentTree[i];
            if (val.keyid == ele.keyid)
            {
              // 如果是数组最后一个则不可以点击，数据不变
              if (i == this.clickParentTree.length - 1)
              {
                return false;
              } else
              {
                ary = this.clickParentTree.filter((item, index) => {
                  return index < i;
                });
              }
            }
          }
          this.clickParentTree = ary;
          this.$forceUpdate();
          // console.log(this.clickParentTree,'this.clickParentTree')
          // 去掉之后再区分（岗位和员工）和其他树
          if (this.whichTree == "station" || this.whichTree == "employee")
          {
            // 岗位和员工树
            // 再获取该父节点下的子节点
            this.checkParent(val);
          } else
          {
            // 其他树
            this.hasLower(val);
          }
          this.$nextTick(()=>{
            this.checkKeyIdBlue(this.clickParentTree)
          })
        }
        this.isAllSelect()
        
      },
      ycZsEmp (value,key) {
        // this.zsEmpInfo.splice(key,1);
        this.allTreeList.forEach(item=>{
          if(item.empid == value.empid){
            item.checked = false;
          }
        })
        this.showEmpInfo.forEach((item,key2)=>{
          if(item.empid == value.empid){
            this.showEmpInfo.splice(key2,1);
          }
        })
        this.zsEmpInfo.forEach((item,key3)=>{
          if(item.empid == value.empid){
            this.zsEmpInfo.splice(key3,1);
          }
        })
        // console.log( this.zsEmpInfo,this.showEmpInfo,'ycZsEmp')
        this.$forceUpdate();
        this.isAllSelect();
        
        this.xsEmpName = this.xsEmpName.replace(value.empname+'，','')
        this.xsEmpName = this.xsEmpName.replace(value.empname+'','')
        console.log(this.xsEmpName,'this.xsEmpName')
        // setTimeout(()=>{
        //     this.getEmpInfoList();
        // },300)
      },
      // 其他树点击下级
      hasLower (val) {
        this.xiaYiJi = val;
        if (val.keyid === this.clickKeyId)
        {
          return;
        }
        this.clickKeyId = val.keyid;
  
        // 储存点击过的有下级的父节点
        if (val.hasLower)
        {
          this.clickParentTree.push(val);
        }
        // 获取此节点下所有子节点
        let array = this.allTreeList.filter((item) => {
          return item.parentid == val.keyid;
        });
        if (array.length > 0)
        {
          this.otherTreeList = [];
          array.forEach((item) => {
            // 判断节点有没有下级
            let lowerAry = this.allTreeList.filter((it) => {
              return it.parentid == item.keyid;
            });
            if (lowerAry.length > 0)
            {
              item.hasLower = true;
            } else
            {
              item.hasLower = false;
            }
            // 父节点
            this.otherTreeList.push(item);
          });
        }
      },
      popAllSelectFun () {
        this.FenYeCurrentPage = 1;
        this.showEmpInfo = this.zsEmpInfo.slice(0,this.pageSize2)
        this.showAllSelectStatus = true;
        this.noHidden = true;
      },
      zeEmpInfoChange () {
        this.showEmpInfo = this.zsEmpInfo.slice((this.FenYeCurrentPage-1)*this.pageSize2,this.FenYeCurrentPage*this.pageSize2)
      },
      onSelectPSearch (n) {
        if(n){
          this.noHidden = false;
          this.showEmpInfo = this.zsEmpInfo.filter((e) => {
            if (e.empcode || e.empname){
              if (e.empcode.indexOf(n) != -1 || e.empname.indexOf(n) != -1){
                return e;
              }
            }
          });
        }else{
          this.noHidden = true;
          this.showEmpInfo = this.zsEmpInfo.slice((this.FenYeCurrentPage-1)*this.pageSize2,this.FenYeCurrentPage*this.pageSize2)
        }
        
      },
      // 点击树的父节点(针对岗位和员工树)
      checkParent (val) {
        if(val.checked){
          return;
        }
        this.xiaYiJi = val;
        // 储存点击过的有下级的父节点
        if (val.hasLower)
        {
          this.clickParentTree.push(val);
        }
        // 获取此父节点下所有节点
        let array = this.allTreeList.filter((item) => {
          return item.parentid == val.keyid;
        });
        
        // 遍历所有节点并分出父节点和子节点
        if (array.length > 0)
        {
          this.parentTreeList = [];
          this.childsTreeList = [];
          let initchilds = []
          array.forEach((item) => {
            
            let array2 = this.allTreeList.filter((u) => {
              return u.parentid == item.keyid;
            });
            if(array2 && array2.length > 0){
              item.childLength = array2.length
            }else{
              item.childLength = 0
            }
            let nodecan = false;
            if (this.whichTree == "station")
            {
              nodecan = item.issta;
            } else if (this.whichTree == "employee")
            {
              nodecan = item.isdept == 0 && item.levelid == 16;
            }
            if (nodecan)
            {
              // 子节点
              initchilds.push(item)
              // this.childsTreeList.push(item);
            } else
            {
              // 判断父节点有没有下级
              let lowerAry = this.allTreeList.filter((it) => {
                return it.parentid == item.keyid;
              });
              if (lowerAry.length > 0)
              {
                item.hasLower = true;
              } else
              {
                item.hasLower = false;
              }
              // 父节点
              this.parentTreeList.push(item);
            }
          });
          
          // 岗位和人员
          if (this.whichTree == "station" || this.whichTree == "employee")
          {
            this.currentPage = 1
            this.totalItems = initchilds.length
            this.allChildsTreeList = initchilds
            this.childsTreeList = initchilds.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
          }
          
        }
        this.isAllSelect();
        this.checkKeyIdBlue()
      },
      // 切换的时候 判断是否全选
      isAllSelect () {
        if(this.childsTreeList.length > 0){
          let mapArr = this.childsTreeList.filter(item=>{
            return !item.checked
          })
          if(mapArr.length == 0){
            this.quanXuanModel = true;
          }else{
            this.quanXuanModel = false;
          }
        }else{
          let mapArr = this.parentTreeList.filter(item=>{
            return !item.checked
          })
          if(mapArr.length == 0){
            this.quanXuanModel = true;
          }else{
            this.quanXuanModel = false;
          }
        }
      },
      // 检查节点是否标注蓝色
      checkKeyIdBlue (arr) {
        let obj = null;
        if(arr && arr.length > 0){
          obj = arr[arr.length - 1]
        }else{
          obj = null;
        }
        if(this.zsEmpInfo.length > 0){
          let empidArr = []
          this.zsEmpInfo.forEach(item=>{
            empidArr.push(item.empid);
            if(this.childsTreeList.length > 0){
              this.childsTreeList.forEach(value=>{
                if(value.empid == item.empid){
                  value.checked = true;
                }
              })
            }
          })
          this.$forceUpdate();
          // 判断节点是否需要勾选
          console.log(this.childsTreeList,'childsTreeListchildsTreeList')
          getEmpDeptAutoIdList({
            empidlist:empidArr.join(","),
            username:this.userInfo.username
          }).then(res=>{
            let resdata = res.data;
            let idarr = [];
            resdata.forEach(item=>{
              if(item.d0){
                idarr.push(item.d0)
              }
              if(item.d1){
                idarr.push(item.d1)
              }
              if(item.d2){
                idarr.push(item.d2)
              }
              if(item.d3){
                idarr.push(item.d3)
              }
              if(item.d4){
                idarr.push(item.d4)
              }
              if(item.d5){
                idarr.push(item.d5)
              }
              if(item.d6){
                idarr.push(item.d6)
              }
              if(item.d7){
                idarr.push(item.d7)
              }
              if(item.d8){
                idarr.push(item.d8)
              }
              if(item.stationid){
                idarr.push(item.stationid)
              }
            })
            let set = new Set(idarr)        
            let newarr = Array.from(set) 
            this.parentTreeList.forEach(item=>{
              if(newarr.includes(item.keyid)){
                item.blueShow = true;
              }else{
                item.blueShow = false;
              }
            })
            this.$forceUpdate();
          })
        }else{
          this.parentTreeList.forEach(item=>{
            item.blueShow = false;
          })
        }
        
        console.log(this.zsEmpInfo,'this.zsEmpInfo')
      },
      // 请求员工列表
      async getEmpInfoList () {
        let array = this.allTreeList.filter((ele) => {
          return ele.checked == true;
        });
        if(array.length > 0){
          let arr1 = [],
              arr2 = [],
              arr3 = [];
          array.forEach(item=>{
            // 本来就是员工了
            if(item.levelid == 16){
              arr1.push(item)
            }else{
              arr2.push(item)
            }
          })
          if(arr1.length > 0){
            arr1.forEach(item=>{
              let obj = {
                empcode:item.empcode,
                empid:item.empid,
                empname:item.empname
              }
              arr3.push(obj)
            })
          }
          if(arr2.length > 0){
            let keyidArr = []
            array.forEach(item=>{
              keyidArr.push(item.keyid)
            })
            const resdata = await getDeptEmpList({
              moduleno: this.module,
              treename: this.treename, // 树名
              username: this.userInfo.username,
              fieldname: this.treename == 'emptree' && this.whereFrom == 'hrQueryPage' ? 'app_select_emplist' : this.fieldname,
              editstate: this.editstate,
              formstr: "",
              deptautoidlist:keyidArr.join(",")
            })
            console.log(resdata,'resdataGetEmpInfoList')
            if(resdata.data){
              let newarr = [...arr3,...resdata.data];
              const uniqueArray = Array.from(new Set(newarr.map(obj => obj.empid))).map(empid => newarr.find(obj => obj.empid === empid));
              
              this.zsEmpInfo = uniqueArray
            }else{
              this.zsEmpInfo = arr3
            }
          }else{
            this.zsEmpInfo = arr3
          }
          if(arr1.length == 0 && arr2.length == 0){
            this.zsEmpInfo = [];
            this.xsEmpName = "";
          }else{
            let arr = [];
            arr = this.zsEmpInfo.slice(0,15);
            let jsarr = []
            arr.forEach(item=>{
              jsarr.push(item.empname)
            })
            this.xsEmpName = jsarr.join("，")
          }
        }else{
          this.zsEmpInfo = [];
          this.xsEmpName = "";
        }
      },
      quanXuanClick () {
        if(this.quanXuanModel){
          if(this.childsTreeList.length > 0){
            this.childsTreeList.forEach(item=>{
              item.checked = true
            })
          }else{
            this.parentTreeList.forEach(item=>{
              item.checked = true
            })
          }
        }else{
          if(this.childsTreeList.length > 0){
            this.childsTreeList.forEach(item=>{
              item.checked = false
            })
          }else{
            this.parentTreeList.forEach(item=>{
              item.checked = false
            })
          }
        }
        this.getEmpInfoList();
        return;
        if(this.childsTreeList.length > 0){
          this.childsTreeList.forEach(item=>{
            item.checked = !item.checked;
            // this.tickParent(item)
          })
        }else{
          this.parentTreeList.forEach(item=>{
            item.checked = !item.checked;
            // this.tickParent(item)
          })
          let array = this.allTreeList.filter((ele) => {
            return ele.checked == true;
          });
          if(array.length > 0){
            let arr1 = [];
            let arr2 = [];
            array.forEach(item=>{
              if(item.levelid == 16){
                arr1.push(item)
              }else{
                arr2.push(item)
              }
            })
            console.log(arr2,'childsTreeList')
            if(arr2.length > 0){
              let keyidArr = []
              arr2.forEach(item=>{
                keyidArr.push(item.keyid)
              })
              getDeptEmpList({
                moduleno: this.module,
                treename: this.treename, // 树名
                username: this.userInfo.username,
                fieldname: this.treename == 'emptree' && this.whereFrom == 'hrQueryPage' ? 'app_select_emplist' : this.fieldname,
                editstate: this.editstate,
                formstr: "",
                deptautoidlist:keyidArr.join(",")
              }).then(res=>{
                if(res.data){
                  this.zsEmpInfo = res.data;
                  let arr = [];
                  arr = res.data.slice(0,15);
                  let jsarr = []
                  arr.forEach(item=>{
                    jsarr.push(item.empname)
                  })
                  this.xsEmpName = jsarr.join("，")
                }
              })
              
            }
          }
        }
        
        
      },
      // 选择父节点复选框
      tickParent (item,index) {
        // 判断父节点有没有下级
        this.isAllSelect();
        this.getEmpInfoList();
      },
      childTickParent () {
        this.isAllSelect();
        this.getEmpInfoList();
      },
      // 多选树清除复选框选中
      cleanChecked () {
        this.allTreeList.forEach((item) => {
          item.checked = false;
        });
      },
      // 多选树确认复选框选中
      async comfirmChecked () {
        this.$emit("treeSelectValEvent", this.zsEmpInfo);
        this.showTreePop = false;
      },
      // 点击树的子节点(暂时单选树)(针对岗位和员工树)
      checkChild (it) {
        console.log(this.xiaYiJi, 'this.xiaYiJi')
        let checked = [];
        this.hasEXfieldlist = [];
        if (this.multiseltree)
        {
          checked = it;
          this.$emit("treeSelectValEvent", it, null, this.xiaYiJi);
        } else
        {
          checked = [it];
          if (this.job)
          {
            if (!this.jobId)
            {
              Toast("请选择工位！");
              return false;
            }
  
            this.$emit("treeSelectValEvent", it, this.jobId, this.xiaYiJi);
          } else
          {
            this.$emit("treeSelectValEvent", it, null, this.xiaYiJi);
          }
  
        }
        this.showTreePop = false;
      },
    },
  };
  </script>
  <style lang="less" scoped>
  .tree_popup {
  
    //   z-index: 6666 !important;
    .tree_title {
      height: 90px;
      text-align: center;
  
      span {
        font-size: 36px;
        font-weight: bold;
      }
    }
  
    .tree_search {
      height: 100px;
    }
  
    .tree_head {
      height: 90px;
      white-space: nowrap;
      overflow-x: auto;
      display: flex;
      align-items: center;
  
      span {
        font-size: 32px;
      }
  
      .theLast {
        color: #969799;
        margin-right: 10px;
        display: flex;
        align-items: center;
      }
  
      .noLast {
        color: #1491f7;
        display: flex;
        align-items: center;
      }
  
      .head_start {
        color: #1491f7;
        padding: 0 0 0 20px;
      }
  
      .division {
        color: #969799;
        display: flex;
        align-items: center;
        img{
          width: 30px;
          height: 30px;
          display: block;
        }
      }
    }
  
    .van-divider::before {
      border-width: 20px 0 0;
    }
  
    .multiseltreeT.tree_body {
      height: calc(100% - 7.1rem) !important; // 多选树时的高度
    }
  
    .single_pagination_tree.tree_body {
      height: calc(100% - 314px - 1rem) !important; // 单选人员或岗位树时的高度
    }
  
    .unSingle_pagination_tree.tree_body {
      height: calc(100% - 314px - 4.13rem) !important; // 多选人员或岗位树时的高度
    }
  
    .tree_body {
      // height: calc(100% - 5.7rem);  // 多选树时的高度
      height: calc(100% - 314px); // 单选树时的高度
      overflow: auto;
  
      .parents_cell {
        .van-checkbox {
          padding-right: 10px;
        }
  
        .van-cell__title {
          flex: 1 1 83%;
        }
  
        .van-cell__value {
          flex: 1 1 17%;
  
          div {
            display: flex;
            align-items: center;
            justify-content: end;
            border-left: 1px solid #969799;
          }
  
          .haveClo {
            color: #1491f7;
          }
  
          .noClo {
            color: #969799;
            pointer-events: none;
          }
  
          .van-icon {
            padding: 0 10px;
          }
        }
      }
  
      .childs_cell,
      .other_cell {
        .van-cell__title {
          display: flex;
          align-items: center;
  
          .van-button {
            border-radius: 12px;
            font-size: 28px;
          }
  
          .check_name {
            padding-left: 10px;
          }
        }
        /deep/.van-checkbox__label{
            display: flex;
            align-items: center;
        }
        /deep/.check_name{
            font-weight: bold !important;
        }
      }
  
      // .other_cell {
      //   .van-cell__title {
      //     display: flex;
      //     align-items: center;
      //     .van-button {
      //       border-radius: 12px;
      //       font-size: 28px;
      //     }
      //   }
      // }
    }
  
    .pagination_box {
      ::v-deep.van-pagination {
        .van-pagination__item {
          height: 1rem !important;
        }
      }
    }
  
    .tree_foot {
      position: absolute;
      bottom: 0;
      width: 100%;
      background: #fff;
      display: flex;
      justify-content: space-evenly;
  
      .van-button {
        width: 30vw;
        margin-bottom: 10px;
      }
    }
  
    /deep/.van-popup__close-icon--top-left {
      top: 25px !important;
      left: 10px !important;
    }
  }
  .quanXuanClass{
    padding: 10px 0 0 20px;
    /deep/.van-checkbox__label{
      font-weight: 600;
      font-size: 32px;
    }
  }
  .staOrEmp_tree{
    /deep/.parents_cell{
      padding: 0.26667rem 0.26667rem !important;
    }
    /deep/.childs_cell{
      padding: 0.26667rem 0.26667rem !important;
    }
  }
  .tree_foot2{
    width: 100%;
    height: 134px;
    background: #FFFFFF;
    box-shadow: 0px -12px 20px 0px rgba(0,0,0,0.1);
    border-radius: 0px 0px 0px 0px;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    align-items: center;
    padding: 0 32px;
    .foot2Left{
      width: 486px;
      max-width: 486px;
      .foot2LeftTop{
        display: flex;
        flex-wrap: nowrap;
        align-items: flex-end;
        .foot2LeftTopWord{
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 30px;
          color: #1989FA;
          line-height: 30px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .foot2LeftTopImg{
          width: 36px;
          height: 36px;
          display: block;
        }
      }
      .foot2LeftBottom{
        width: 100%;
        padding-right: 22px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 28px;
        color: #1989FA;
        line-height: 30px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        margin-top: 6px;
      }
    }
    .foot2Right{
      width: 200px;
      max-width: 200px;
      min-width: 200px;
      border-radius:10px;
      height: 68px;
    }
  }
  .winAllSelectZindexDiv{
    .winAllSelectZindexDiv_info{
      padding: 0 0.32rem;
      height: 600px;
      overflow: auto;
    }
    .winAllSelectZindexDiv_infoBox{
      display: flex;
      flex-wrap: nowrap;
      border-bottom: 1px solid rgba(153,153,153,0.3);
      align-items: center;
      padding-top: 25px;
      padding-bottom: 25px;
    }
    .winAllSelectZindexDiv_infoLeft{
      width: 60px;
      min-width: 60px;
      .winAllSelectZindexDiv_infoLeftImg{
        width: 100%;
        display: block;
      }
    }
    .winAllSelectZindexDiv_infoRightUser{
      .winAllSelectZindexDiv_infoRightUserName{
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 32px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      .winAllSelectZindexDiv_infoRightUserCode{
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 24px;
        color: #999999;
        line-height: 30px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-top: 5px;
      }
    }
    .winAllSelectZindexDiv_infoRight{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 26px;
    }
    .winAllSelectZindexDiv_infoRightBtn{
      display: flex;
      align-items: center;
    }
    .winAllSelectZindexDiv_infoRightBtnBtn{
      width: 132px;
      height: 55px;
      font-size: 26px;
      border-radius: 5px 5px 5px 5px;
    }
    .winAllSelectZindexDiv_FenYe{
      box-shadow: -5px 0px 5px #ccc;
      padding: 15px 0;
    }
    .winAllSelectZindexDiv_Footer{
      display: flex;
      justify-content: space-around;
      padding: 15px 0;
      box-shadow: -5px 0px 5px #ccc;
      .btn11{
        width: 300px;
        height: 80px;
        border-radius: 10px;
      }
      .btn22{
        width: 300px;
        height: 80px;
        border-radius: 10px;
      }
    }
    .winAllSelectZindexDiv_Top{
      padding-top: 30px;
      padding-bottom: 30px;
      border-bottom: 1px solid rgba(153,153,153,0.3);
      padding-left: 0.32rem;
      padding-right: 0.32rem;
    }
    .winAllSelectZindexDiv_TopWord{
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 32px;
      color: #333333;
      line-height: 30px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
  .titleShowBlueClass{
    color: blue !important;
    /deep/.van-cell__title{
      span{
        color: blue !important;
      }
    }
  }
  </style>